import { LISTAR_RAMAIS, SELECIONAR_RAMAL, LISTAR_TRONCOS, LISTAR_ROTAS, LISTAR_GRUPOS, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

export default {
  [LISTAR_RAMAIS]: (state, ramais) => {
    state.ramais = ramais
  },
  [LISTAR_TRONCOS]: (state, troncos) => {
    state.troncosDisponiveis = troncos
  },
  [SELECIONAR_RAMAL]: (state, ramal) => {
    state.ramalSelecionado = ramal
  },
  [LISTAR_ROTAS]: (state, rotas) => {
    state.rotasDisponiveis = rotas
  },
  [LISTAR_GRUPOS]: (state, grupos) => {
    state.grupos = grupos
  },
  [LISTAR_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
  },
}
